export const createBlobUrl = (file: File | Blob) => {
  const winUrl = window.URL || window.webkitURL;
  return winUrl.createObjectURL(file);
};

export const revokeBlobUrl = (url: string) => {
  const winUrl = window.URL || window.webkitURL;
  return winUrl.revokeObjectURL(url);
};
